import createService from './createService';

export const backend = createService();
